import { Component } from '@angular/core';

@Component({
    selector: 'app-drivers-stat',
    templateUrl: './drivers-stat.component.html',
    styleUrls: ['./drivers-stat.component.css'],
    standalone: false
})
export class DriversStatComponent {
}
